var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamersensei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ng-scope",
    fill: "none",
    viewBox: "0 0 67.726 67.499",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-emblem",
    d: "M67.726 67.5H0V0h67.726v7.5H7.525V60h52.676V22.5H22.575V30h30.1v22.5H15.049V45h30.1v-7.5h-30.1V15h52.676z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamersensei);
export default __webpack_public_path__ + "static/media/gamersensei.7dfe5148301949f38e4e7ed7d173a87c.svg";
export { ForwardRef as ReactComponent };